import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

import IconButton from 'components/common/IconButton';
import Menu, { MenuItem } from 'components/common/Menu';
import DeleteMenu from 'components/common/DeleteMenu';
import IconPen from 'components/icons/IconPen';
import IconTrashCan from 'components/icons/IconTrashCan';

import { deletePatientMessageTemplate } from 'redux/modules/patientsMessagesTemplates';

import NotificationsDialogTemplatesItemEditForm from './NotificationsDialogTemplatesItemEditForm';

const styles = theme => ({
  root: {
    maxWidth: 600,
    borderTop: 5,
    paddingRight: 0,
    borderBottom: 5,
    '& + $root': {
      borderTop: `1px solid ${theme.palette.primary.A100}`,
    },
  },
  gridItemShrink: {
    flexShrink: 1,
  },
  linkRemove: {
    paddingTop: 10,
    paddingBottom: 10,
    marginTop: -10,
    marginBottom: -10,
  },
  listItemSecondaryAction: {
    position: 'static',
    margin: 0,
    transform: 'none',
  },
  iconButton: {
    marginTop: -13,
    marginBottom: -13,
  },
  iconPen: {
    width: 16,
    height: 16,
  },
  iconTrashCan: {
    width: 14,
    height: 18,
  },
  typographyContent: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

class NotificationsDialogTemplatesItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      edit: false,
    };

    this.onMenuClose = this.onMenuClose.bind(this);
    this.onDeleteButtonClick = this.onDeleteButtonClick.bind(this);
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
    this.onDeleteSubmit = this.onDeleteSubmit.bind(this);
    this.onEditButtonClick = this.onEditButtonClick.bind(this);
    this.onEditCancel = this.onEditCancel.bind(this);
    this.onEditSubmitSucces = this.onEditSubmitSucces.bind(this);
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onDeleteButtonClick(event) {
    event.stopPropagation();
    this.setState({ anchorEl: event.currentTarget });
  }

  onDeleteCancel() {
    this.setState({ anchorEl: null });
  }

  onDeleteSubmit() {
    const { actions, ID } = this.props;
    this.setState({ anchorEl: null });
    actions.deletePatientMessageTemplate({ ID });
  }

  onEditButtonClick(event) {
    event.stopPropagation();
    this.setState({ edit: true });
  }

  onEditCancel() {
    this.setState({ edit: false });
  }

  onEditSubmitSucces() {
    this.setState({ edit: false });
  }

  render() {
    const {
      ID,
      classes,
      Content,
      onTemplateSelect,
    } = this.props;
    const { anchorEl, edit } = this.state;
    const open = Boolean(anchorEl);
    return (
      <MenuItem
        className={classes.root}
        {...open || edit ? { disableRipple: true } : {
          onClick: () => onTemplateSelect(Content),
        }}
      >
        <div>
          {edit ? (
            <NotificationsDialogTemplatesItemEditForm
              form={`${ID}-notificationTemplateEditForm`}
              initialValues={{
                Content,
                ID,
              }}
              onCancel={this.onEditCancel}
              onSubmitSuccess={this.onEditSubmitSucces}
              onClick={(event) => {
                event.stopPropagation();
              }}
            />
          ) : (
            <Grid
              container
              spacing={24}
              alignItems="center"
              wrap="nowrap"
            >
              <Grid
                className={classes.gridItemShrink}
                item
                xs={9}
              >
                <Typography className={classes.typographyContent} align="left">
                  {Content}
                </Typography>
              </Grid>
              <Grid
                item
              >
                <ListItemSecondaryAction className={classes.listItemSecondaryAction}>
                  <IconButton
                    /* eslint-enable camelcase */
                    className={classes.iconButton}
                    aria-label="Remove"
                    aria-owns={open ? `${ID}-notifications-template-remove-menu` : null}
                    aria-haspopup="true"
                    onClick={this.onDeleteButtonClick}
                    tooltipContent="Delete"
                  >
                    <IconTrashCan className={classes.iconTrashCan} />
                  </IconButton>
                  <IconButton
                    className={classes.iconButton}
                    onClick={this.onEditButtonClick}
                    tooltipContent="Edit"
                  >
                    <IconPen className={classes.iconPen} />
                  </IconButton>
                  <Menu
                    id={`${ID}-notifications-template-remove-menu`}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={this.onMenuClose}
                    list={false}
                  >
                    <DeleteMenu
                      text="Are you sure you want to delete this template?"
                      onCancel={this.onDeleteCancel}
                      onSubmit={this.onDeleteSubmit}
                    />
                  </Menu>
                </ListItemSecondaryAction>
              </Grid>
            </Grid>
          )}    
        </div>
      </MenuItem>
    );
  }
}

NotificationsDialogTemplatesItem.propTypes = {
  ID: PropTypes.number.isRequired,
  Content: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  actions: PropTypes.shape({
    deletePatientMessageTemplate: PropTypes.func.isRequired,
  }).isRequired,
  onTemplateSelect: PropTypes.func,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    gridItemShrink: PropTypes.string.isRequired,
    linkRemove: PropTypes.string.isRequired,
    listItemSecondaryAction: PropTypes.string.isRequired,
  }).isRequired,
};

NotificationsDialogTemplatesItem.defaultProps = {
  onClick: null,
  onTemplateSelect: () => {},
};


const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ deletePatientMessageTemplate }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  withStyles(styles)(NotificationsDialogTemplatesItem),
);



// WEBPACK FOOTER //
// ./src/components/patient/NotificationsDialog/NotificationsDialogTemplatesItem.js